<template>
  <TronBox canvas-id="grid" />
</template>

<script>
import TronBox from "./components/tron-box/tron-box.vue";

export default {
  name: "App",
  components: {
    TronBox
  },
};
</script>

<style>
</style>
